var CRcarrierServiceEnabled = true;
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;
var specialProduct4 = false;
var specialProduct5 = false;
var specialProduct6 = false;
var specialProduct7 = false;
var specialProduct8 = false;
var specialProduct9 = false;
var specialProduct10 = false;
var specialProduct11 = false;


for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemTitle.toLowerCase().indexOf('Alla hjärtans meny för 2 personer'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }  

  if (itemCollections.toLowerCase().indexOf('Påsken'.toLowerCase()) > -1) {
    specialProduct2 = true;
  }  

  if (itemTitle.toLowerCase().indexOf('Klassisk råbiff'.toLowerCase()) > -1) {
    specialProduct3 = true;
  }  

  if (itemCollections.toLowerCase().indexOf('Catering'.toLowerCase()) > -1) {
    specialProduct4 = true;
  }  
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  console.log({selectedStore})
  /*if (specialProduct1 === true) {
      picker.set('disable', [true,         
      { from: [2020, 8, 30], to: [2026, 1, 12] }, 
      { from: [2026, 1, 15], to: [2045, 9, 6] }                           
      ]);
  }*/

  /*if (specialProduct2 === true) {
      picker.set('disable', [true,         
      { from: [2020, 8, 30], to: [2026, 2, 29] }, 
      { from: [2026, 3, 3], to: [2026, 3, 3] },
      { from: [2026, 3, 5], to: [2046, 3, 3] },
      ]);
  } else if (specialProduct3 === true) {
      picker.set('disable', [true,         
      
      { from: [2025, 3, 3], to: [2026, 2, 19] },
      { from: [2026, 2, 22], to: [2046, 3, 3] },
      ]);
  } else {*/
    picker.set('disable', blackoutdatesCollection);
  /*}*/

  // if (specialProduct4 === true) {
  //     picker.set('disable', [true,         
  //     1
  //     ]);
  // }
  
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  

  if (specialProduct1 === true) {
    if(selectedDate.getDate() === 13 && selectedMonth === 1 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[12, 0]);       
      timepicker.set('max',[17, 45]); 
    } else {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[14, 0]); 
    }
    
  }
  
  if (specialProduct3 === true) {
    if(selectedDate.getDate() === 20 && selectedMonth === 2 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[18, 0]); 
    } else {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[15, 0]); 
    }
    
  }

  if (specialProduct2 === true) {
    if(selectedDate.getDate() === 30 && selectedMonth === 2 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[17, 0]); 
    } 

    if(selectedDate.getDate() === 31 && selectedMonth === 2 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[17, 0]); 
    } 

    if(selectedDate.getDate() === 1 && selectedMonth === 3 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[18, 30]); 
    } 

    if(selectedDate.getDate() === 2 && selectedMonth === 3 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[18, 30]); 
    } 
    
    if(selectedDate.getDate() === 4 && selectedMonth === 3 && selectedDate.getFullYear() === 2026) {
      timepicker.set('min',[10, 0]);       
      timepicker.set('max',[15, 0]); 
    } 
  }  	
}

document.addEventListener('crDeliveryActivated', async function (e) {
  console.log('_____Delivery activated');
  const cart = await storePickup.getCartItems();
  // console.log(cart);

  // If your addLineProperty expects a cart + value:
  await storePickup.addLineProperty(cart, 'delivery');
})

document.addEventListener('crPickupActivated', async function (e) {
  console.log('_____Pickup activated');
  const cart = await storePickup.getCartItems();
  // console.log(cart);

  // If your addLineProperty expects a cart + value:
  await storePickup.addLineProperty(cart, 'pickup');
})